import { LocalGridFragment, LocalGridType } from '../generated/graphql'
import { SystemContainerCalculator } from './SystemContainerCalculator'
import { createMapFragmentToProvider } from './providers/util/fragment-to-provider-mapper'
import { addDemandsToLocalGridProviders } from '../local-grid/local-grid-util'

export class LocalGridCalculator extends SystemContainerCalculator {
  public type!: LocalGridType

  public setType(type: LocalGridType): void {
    this.type = type
  }
}

export function createMapLocalGridToLocalGridCalculator(
  temperatureValues?: number[],
) {
  return (localGrid: LocalGridFragment): LocalGridCalculator => {
    const newLocalGrid = new LocalGridCalculator(localGrid.id)

    newLocalGrid.setType(localGrid.type)

    localGrid.providers
      .map(addDemandsToLocalGridProviders(newLocalGrid.type))
      .map(createMapFragmentToProvider(temperatureValues))
      .forEach((provider) => newLocalGrid.addProvider(provider))

    return newLocalGrid
  }
}
